module.exports = __webpack_public_path__ + "img/fan_error_gr.14005297.svg";